export const PARTNUMBERS_CREATE_EDIT_OPEN_MODAL = "PARTNUMBERS_CREATE_EDIT_OPEN_MODAL";

export const PARTNUMBERS_CREATE_REQUEST = "PARTNUMBERS_CREATE_REQUEST";
export const PARTNUMBERS_CREATE_RESULT = "PARTNUMBERS_CREATE_RESULT";

export const PARTNUMBERS_UPDATE_REQUEST = "PARTNUMBERS_UPDATE_REQUEST";
export const PARTNUMBERS_UPDATE_RESULT = "PARTNUMBERS_UPDATE_RESULT";

export const PARTNUMBERS_GET_REQUEST = "PARTNUMBERS_GET_REQUEST";
export const PARTNUMBERS_GET_RESULT = "PARTNUMBERS_GET_RESULT";